import { createFileRoute } from "@tanstack/react-router";
import { applicationPhoneSignInRoute } from "@/features/applications";

export const Route = createFileRoute("/application/$token_/sign-in")({
    ...applicationPhoneSignInRoute,
});
